import * as i0 from '@angular/core';
import { Injectable, Component, Inject, NgModule } from '@angular/core';
import { init, pageViewObserver, resolveSimpleEvent, resolveDataEvent, sendEmail } from '@bloomscorp/bloomsight.js';
import * as i1 from '@angular/router';
import { NavigationEnd } from '@angular/router';

class NgxBloomsightService {
    constructor() { }
}
NgxBloomsightService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: NgxBloomsightService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
NgxBloomsightService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: NgxBloomsightService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: NgxBloomsightService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

class NgxBloomsightComponent {
    constructor() { }
    ngOnInit() {
    }
}
NgxBloomsightComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: NgxBloomsightComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
NgxBloomsightComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: NgxBloomsightComponent, selector: "lib-ngx-bloomsight", ngImport: i0, template: `
    <p>
      ngx-bloomsight works!
    </p>
  `, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: NgxBloomsightComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lib-ngx-bloomsight', template: `
    <p>
      ngx-bloomsight works!
    </p>
  ` }]
        }], ctorParameters: function () { return []; } });

class BloomsightEventService {
    constructor(_config, _router) {
        this._config = _config;
        this._router = _router;
        this._previousUrl = '';
        this.init();
        this.pageViewObserver();
    }
    init() {
        init(this._config);
    }
    pageViewObserver() {
        this._router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                if (this._previousUrl !== event.url) {
                    pageViewObserver();
                }
                this._previousUrl = event.url;
            }
        });
    }
    resolveSimpleEvent(eventToken, label = '') {
        resolveSimpleEvent(eventToken, label);
    }
    resolveDataEvent(eventToken, eventData, label = '') {
        resolveDataEvent(eventToken, eventData, label);
    }
}
BloomsightEventService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BloomsightEventService, deps: [{ token: 'bloomsightConfig' }, { token: i1.Router }], target: i0.ɵɵFactoryTarget.Injectable });
BloomsightEventService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BloomsightEventService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BloomsightEventService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: ['bloomsightConfig']
                }] }, { type: i1.Router }]; } });

class BloomsightMailService {
    constructor(_config) {
        this._config = _config;
        this.init();
    }
    init() {
        init(this._config);
    }
    sendMail(engineId, templateId, templateOwnerId, emailMetaData, onSuccess, onError) {
        sendEmail(engineId, templateId, templateOwnerId, emailMetaData, onSuccess, onError);
    }
}
BloomsightMailService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BloomsightMailService, deps: [{ token: 'bloomsightConfig' }], target: i0.ɵɵFactoryTarget.Injectable });
BloomsightMailService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BloomsightMailService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BloomsightMailService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: ['bloomsightConfig']
                }] }]; } });

class NgxBloomsightModule {
    static forRoot(bloomsightConfig) {
        return {
            ngModule: NgxBloomsightModule,
            providers: [
                BloomsightEventService,
                BloomsightMailService,
                { provide: 'bloomsightConfig', useValue: bloomsightConfig }
            ]
        };
    }
}
NgxBloomsightModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: NgxBloomsightModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
NgxBloomsightModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: NgxBloomsightModule, declarations: [NgxBloomsightComponent], exports: [NgxBloomsightComponent] });
NgxBloomsightModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: NgxBloomsightModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: NgxBloomsightModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        NgxBloomsightComponent
                    ],
                    imports: [],
                    exports: [
                        NgxBloomsightComponent
                    ]
                }]
        }] });

/*
 * Public API Surface of ngx-bloomsight
 */

/**
 * Generated bundle index. Do not edit.
 */

export { BloomsightEventService, BloomsightMailService, NgxBloomsightComponent, NgxBloomsightModule, NgxBloomsightService };
